export default {
    i18nKey: 'persona2',
    firstName: 'Steve',
    lastName: 'Pendleton',
    personaPrefix: 'SP_',
    image: '../assets/img/Persona2.jpg',
    index: 1,
    videoPrefix: 'SP-',
    personaDataAction: 'Managers'    
}